import dynamic from "next/dynamic";
import SEO from "./seo";
import Hero from "@/components/hero";

/**
 * Hero is statically imported: next/dynamic wrappers were briefly unmounting
 * the SSR hero during hydration (main child count dropped), which caused
 * mobile CLS of ~0.7-0.9 on course templates as pricing/accordion jumped.
 *
 * Other modules stay dynamic to avoid circular ComponentMap dependency issues
 * during static generation.
 */
const Intro = dynamic(() => import("@/components/intro"));
const Testimonial = dynamic(() => import("@/components/testimonial"));
const Content = dynamic(() => import("@/components/content"));
const Grid = dynamic(() => import("@/components/grid"));
const Panel = dynamic(() => import("@/components/panel"));
const Card = dynamic(() => import("@/components/card"));
const Earnings = dynamic(() => import("@/components/earnings"));
const Pricing = dynamic(() => import("@/components/pricing"), {
  loading: () => (
    <div className="min-h-[28rem] bg-gray-100" id="pricing" aria-hidden="true" />
  ),
});
const Horizontal = dynamic(() => import("@/components/panels/horizontal"));
const Split = dynamic(() => import("@/components/panels/split"));
const FullCentered = dynamic(() => import("@/components/panels/centered"));
const Justified = dynamic(() => import("@/components/panels/justified"));
const Stacked = dynamic(() => import("@/components/panels/stacked"));
const Accordion = dynamic(() => import("@/components/accordion"), {
  loading: () => <div className="min-h-[12rem] bg-slate-100" aria-hidden="true" />,
});
const OnlineBooking = dynamic(() => import("@/components/online-booking"));
const PTItem = dynamic(() => import("@/components/practitioner-item"));
const Banner = dynamic(() => import("@/components/banner"));
const newCourse = dynamic(() => import("@/components/content-types/new-course"));
const ContentfulRpl = dynamic(() => import("@/components/rpl"));

export const ComponentMap = {
  intro: Intro,
  article: Content,
  testimonial: Testimonial,
  contentReferenceGrid: Grid,
  panel: Panel,
  card: Card,
  horizontalPanel: Horizontal,
  splitPanel: Split,
  hero: Hero,
  pricing: Pricing,
  earnings: Earnings,
  centered: FullCentered,
  justified: Justified,
  stacked: Stacked,
  accordion: Accordion,
  onlineCourseBooking: OnlineBooking,
  practitionerDayItem: PTItem,
  banner: Banner,
  seoBlock: SEO,
  newCourseTypeModule: newCourse,
  rpl: ContentfulRpl,
};
